import { clientePedido } from '../../apiClient/index'

function initialState () {
  return {
    filtrosArchivos: undefined,
    vueFinderPath: undefined,
    vueFinderFullscreen: false,
    vueFinderCapabilities: undefined
  }
}
const moduloArchivos = {
  namespaced: true,
  state: initialState,
  actions: {
    
    getArchivos(context, payload) 
    {   
      return new Promise((resolve) => {
        clientePedido.get('/api/Archivo/FindArchivos', { params: payload })

      .then(response => resolve(response.data))
      })
    },

    getArchivosNoVencidos(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Archivo/FindArchivosNoVencidos', { params: payload })
      .then(response => resolve(response.data))
      })
    },

    getArchivo(context, payload) {
      return new Promise((resolve)=> {
        clientePedido.get('/api/Archivo/Get', {params: payload})
        .then(response => resolve(response.data))
      })
    },

    getJerarquiaCarpetas() {
      return new Promise((resolve)=> {
        clientePedido.get('/api/Archivo/GetJerarquiaCarpetas')
        .then(response => resolve(response.data))
      })
    },

    getVueFinderCapabilities(context) {
      return clientePedido.get('/api/VueFinder/capabilities')
        .then(response => {
          const data = response.data || {}
          const capabilities = {
            delete: data.delete === true,
            move: data.move === true
          }

          context.commit('setVueFinderCapabilities', capabilities)
          return capabilities
        })
        .catch(() => {
          const capabilities = { delete: false, move: false }
          context.commit('setVueFinderCapabilities', capabilities)
          return capabilities
        })
    },

    downloadFile(context, payload) {
      return clientePedido.get('/api/Archivo/DownloadFile', {
        params: {
          idUsuario: payload.idUsuario,
          idPerfiles: Array.isArray(payload.idPerfiles)
            ? payload.idPerfiles.join(',')
            : payload.idPerfiles,
          id: payload.idNodo
        },
        responseType: 'arraybuffer'
      })
    },
    getLink(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.get('/api/Archivo/GetLink', {params: payload}).then(response => {
          resolve(response.data)
        })
        .catch(error => reject(error))
      })
    },

    uploadArchivo(context, payload) {             
      // armo el payload
      let formData = new FormData()
      formData.append('imagen', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        clientePedido.post(`/api/Archivo/UploadArchivo?id=${payload.id}`, formData)
        .then(          
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
      
    },
    eliminarTemporal(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.delete('/api/Archivo/EliminarTemporal', { params: { idTemporal: payload.idTemporal } })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    saveArchivo(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.post('/api/Archivo/Save', payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
      })
    },
    setFiltrosArchivos(context, payload) {
      // guardo los filtros aplicados      
      context.commit('setFiltrosArchivos', payload)
    },
    eliminar(context, payload)
    {
      return new Promise((resolve)=> {
        clientePedido.post(`/api/Archivo/Eliminar?id=${payload.id }`)
        .then(response => {
          resolve(response.data)
        })
      })
    },
    getArchivosJerarquia(context, payload)
    {
      return new Promise((resolve, reject)=>{
        clientePedido.get(`/api/Archivo/GetJerarquia?idUsuario=${payload.idUsuario}&idPerfiles=${payload.idPerfiles}&idNodo=${payload.idNodo}`)
        .then(response => 
          resolve(response.data))
        .catch(() => reject());
      })
    }
  },
  mutations: {
    setFiltrosArchivos(state, payload) {
      state.filtrosArchivos = payload
    },
    setVueFinderPath(state, payload) {
      state.vueFinderPath = payload
    },
    setVueFinderFullscreen(state, payload) {
      state.vueFinderFullscreen = payload
    },
    setVueFinderCapabilities(state, payload) {
      state.vueFinderCapabilities = payload
    }
  },
  getters: {
    vueFinderPath(state) {
      return state.vueFinderPath
    },
    vueFinderCapabilities(state) {
      return state.vueFinderCapabilities
    }
  }
}

export default moduloArchivos